import type { StartDateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';
import { atom } from 'recoil';

export const startDateAtom = atom<StartDateDTO[]>({
    key: 'startDateAtom',
    default: undefined
});
